export const rpcBaseUrl = new URL(
  import.meta.env.VITE_API_URL || "/api",
  location.origin
).href.replace(/\/$/, "");
export const identityUrl = (
  import.meta.env.VITE_IDENTITY_URL || "https://accounts.tradestorm.io"
).replace(/\/$/, "");
export const oauthClientId = import.meta.env.VITE_OAUTH_CLIENT_ID || "cid_37a644ce063b4849";
export const callbackUrl = () => new URL("/oauth/callback", location.origin).href;
